export enum PopupBannerPublishedTypeEnum {
  Now = 'NOW',
  Period = 'PERIOD',
}
